import React, { useState, useEffect } from "react";

import { Tab, Tabs, TabList, TabPanel } from "react-tabs";

import "react-tabs/style/react-tabs.css";

import axios from "axios";



import { Helmet } from "react-helmet";

import Modal from "react-bootstrap/Modal";

import { api } from "../Constants";

import ReCAPTCHA from "react-google-recaptcha";

import { Link, useNavigate } from "react-router-dom";

import { useSelector, useDispatch } from "react-redux";

import { addtoCart } from "../../features/cartSlice";

import { toast } from "react-toastify";



function Ourproduct() {

  const [productdetails, setProductDetails] = useState([]);

  const [categorylist, setCategorylist] = useState([]);

  const [selectedCategoryId, setSelectedCategoryId] = useState(null);



  const dispatch = useDispatch();



  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);

  const userid = localStorage.getItem("userid");



  var subject = "testing";



  const handleShow = (item) => {

    setShow(true);

    setFormData({

      ...formData,

      product_code: item.product_code,

      product_id: item.product_id,

      dealer_id: userid,

      subject: subject,

    });

  };



  const handleChange = (e) => {

    const { name, value } = e.target;

    setFormData({ ...formData, [name]: value });

  };



  const handleChange1 = (e) => {

    const { name, value } = e.target;

    setFormData({ ...formData, [name]: value });

  };



  const handleChange2 = (e) => {

    const { name, value } = e.target;

    setFormData({ ...formData, [name]: value });

  };



  const handleChange3 = (e) => {

    const { name, value } = e.target;

    setFormData({ ...formData, [name]: value });

  };



  const handleChange4 = (e) => {

    const { name, value } = e.target;

    setFormData({ ...formData, [name]: value });

  };



  const [formData, setFormData] = useState({

    name: "",

    mobile: "",

    email: "",

    city: "",

    message: "",

    subject,

  });



  const handleClick = () => {

    if (

      !formData.name == "" &&

      !formData.mobile == "" &&

      !formData.email == "" &&

      !formData.city == "" &&

      !formData.message == ""

    ) {

      fetch(api + "add_enquirydetails", {

        method: "POST",

        headers: {

          Accept: "application/json",

          "Content-Type": "application/json;charset=UTF-8",

          changeOrigin: true,

        },

        body: JSON.stringify(formData),

      }).then((response) => {

        if (response.status === 200) {

          alert("send message succesfully");

          handleClose();

        } else alert("some error is occured");

      });

    }

  };



  useEffect(() => {

    axios

      .post(api + "category_list")

      .then((response) => {

        setCategorylist(response.data.data);

        if (response.data.data !== undefined && response.data.data.length > 0) {

          setSelectedCategoryId(response.data.data[0].category_slug);

        }

      })

      .catch((error) => {

        console.error("Error fetching category list:", error);

      });

  }, []);



  useEffect(() => {

    if (selectedCategoryId !== null) {

      axios

        .post(api + "search_productcategory", {

          category: selectedCategoryId,

          dealer_id: userid,

        })

        .then((res) => {

          setProductDetails(res.data.data);

        })

        .catch((error) => {

          console.error("Error fetching product details:", error);

        });

    }

  }, [selectedCategoryId]);



  const handleCategoryClick = (category_slug) => {

    setSelectedCategoryId(category_slug);

  };



  function onChange(value) {

    console.log("Captcha value:", value);

  }



  // const handleAddtocart = (product_id) => {

  //   if (userid) {

  //     dispatch(addtoCart({product_id, userid}));



  //   }

  // };



  const [showcart, setShowcart] = useState(false);

  const handleClosecart = () => setShowcart(false);



  const handleShowcart = (item) => {

    setShowcart(true);

    carsetFormData((prev) => ({

      ...prev,

      product_id: item.product_id,

      product_code: item.product_code,

      quantity_variant: item.quantity_variant || "Pair",

    }));

  };



  // Add this at the top of your component

  const [cartformData, carsetFormData] = useState({

    qty: "",

    sizes: "",

    carat: "",

    weight: "",

    remarks: "",

    quantity_variant: "",

  });

  const [loading, setLoading] = useState(false);

  const [error, setError] = useState("");



  const carthandleChange = (e) => {

    const { name, value } = e.target;

    carsetFormData((prev) => ({

      ...prev,

      [name]: value,

    }));

  };



  const handleSubmit = async (e) => {

    e.preventDefault();



    const userids = userid;

    const product_id = parseInt(cartformData.product_id);

    const qty = parseInt(cartformData.qty);

    const size = cartformData.sizes;

    const carat = cartformData.carat;

    const weight = cartformData.weight;

    const remarks = cartformData.remarks;



    if (userid) {

      try {

        const resultAction = await dispatch(

          addtoCart({ product_id, userids, qty, size, carat, weight, remarks })

        );



        if (

          resultAction.meta.requestStatus === "fulfilled" ||

          resultAction.payload.success

        ) {

          // Adjust condition based on your setup

          handleClosecart();

          carsetFormData((prev) => ({

            ...prev,

            qty: "",

            sizes: "",

            carat: "",

            weight: "",

            remarks: "",

          }));

        }

      } catch (error) {

        console.error("Failed to add to cart:", error);

        // Handle error appropriately (e.g., show a message to the user)

      }

    }

  };



  return (

    <div>

      <div>

        <Helmet>Category ||Arthika jewels</Helmet>

      </div>

      <section className="feature-product section-padding">

        <div className="container">

          <div className="row">

            <div className="col-12">

              <div className="section-title text-center">

                <h2 className="title">Our products</h2>

              </div>

            </div>

          </div>



          <div className="row">

            <Tabs>

              <div className="product-tab-menu">

                <ul className="nav justify-content-center">

                  <TabList className="nav justify-content-center">

                    {categorylist !== undefined && categorylist.length > 0

                      ? categorylist.slice(0, 4).map((category) => (

                          <Tab key={category.category_slug}>

                            <li>

                              <button

                                onClick={() =>

                                  handleCategoryClick(category.category_slug)

                                }

                                data-bs-toggle="tab"

                              >

                                {category.name}

                              </button>

                            </li>

                          </Tab>

                        ))

                      : null}

                  </TabList>

                </ul>

              </div>

              <div className="col-12">

                <div>

                  {categorylist !== undefined && categorylist.length > 0

                    ? categorylist.map((category) => (

                        <TabPanel key={category.category_slug}>

                          {category.category_slug === selectedCategoryId && (

                            <div className="row">

                              {productdetails !== undefined &&

                              productdetails.length > 0

                                ? productdetails.map((item) => (

                                    <div

                                      key={item.product_id}

                                      className="col-6 col-sm-6  col-md-4  col-lg-3"

                                    >

                                      <div className="product-item">

                                        <figure className="product-thumb">

                                          <Link

                                            to={`/product-details/${item.prd_slug_name}`}

                                          >

                                            <img

                                              className="pri-img our-products-home"

                                              src={item.product_image}

                                              alt="product"

                                            />

                                          </Link>



                                          <div className="cart-hover">

                                            {userid ? (

                                              <>

                                                <button

                                                  className="btn btn-cart"

                                                  onClick={() => {

                                                    handleShowcart(item);

                                                  }}

                                                >

                                                  Add to Cart

                                                </button>

                                              </>

                                            ) : (

                                              <>

                                                <button

                                                  className="btn btn-cart"

                                                  onClick={() => {

                                                    handleShow(item);

                                                  }}

                                                >

                                                  Enquiry Now

                                                </button>

                                              </>

                                            )}

                                          </div>

                                        </figure>

                                        <div className="product-caption text-center">

                                          <h6 className="product-name">

                                            <Link

                                              to={`/product-details/${item.prd_slug_name}`}

                                            >

                                              {item.category_name}

                                            </Link>

                                          </h6>

                                          <div className="product-identity">

                                            <p className="manufacturer-name">

                                              Qty :{" "}

                                              <span className="price-regular">

                                                {item.quantity}&nbsp;{item.quantity_variant}

                                              </span>

                                            </p>

                                          </div>

                                          <div className="product-identity">

                                            <p className="manufacturer-name">

                                              Weight :

                                              <span className="price-regular" style={{paddingLeft:'3px'}}>

                                              

                                                {item.weight} g

                                              </span>

                                            </p>

                                          </div>

                                          <div className="price-box">

                                            <span className="price-old">

                                             

                                               SKU :{" "}

                                            </span>

                                            <span className=" price-regular">

                                              {" "}

                                                {item.product_code}

                                            </span>

                                          </div>

                                          

                                        </div>

                                      </div>

                                    </div>

                                  ))

                                : null}

                            </div>

                          )}

                        </TabPanel>

                      ))

                    : null}



                  <Modal

                    show={show}

                    onHide={handleClose}

                    className="modal fade entry-popup"

                  >

                    <div className="modal-header">

                      <h5 className="modal-title" id="exampleModalLabel">

                        {" "}

                        <span>For Enquiry Enter Your Details</span>

                      </h5>

                      <button

                        type="button"

                        className="close"

                        data-dismiss="modal"

                        aria-label="Close"

                        style={{ border: "none" }}

                        onClick={() => {

                          setShow(false);

                        }}

                      >

                        <span className="contactclosebutton" aria-hidden="true">

                          &times;

                        </span>

                      </button>

                    </div>

                    <Modal.Body>

                      <form method="POST" action="javascript:void(0)">

                        <div className="row mb3 g-3">

                          <div className="col-lg-12 col-md-12 mb20">

                            <input

                              type="text"

                              className="form-control"

                              placeholder="Your Name"

                              id="name"

                              name="name"

                              value={formData.name}

                              onChange={handleChange}

                              onKeyPress={(event) => {

                                if (!/[a-z,A-Z]/.test(event.key)) {

                                  event.preventDefault();

                                }

                              }}

                              required

                            ></input>

                          </div>

                          <div className="col-lg-12 col-md-12 mb20">

                            <input

                              type="text"

                              className="form-control"

                              placeholder="Phone Number"

                              id="mobile"

                              name="mobile"

                              value={formData.mobile}

                              onChange={handleChange1}

                              maxLength="10"

                              onKeyPress={(event) => {

                                if (!/[0-9]/.test(event.key)) {

                                  event.preventDefault();

                                }

                              }}

                              required

                            ></input>

                          </div>

                          <div className="col-lg-12 col-md-12 mb20">

                            <input

                              type="email"

                              className="form-control"

                              placeholder="Email Address"

                              id="email"

                              name="email"

                              value={formData.email}

                              onChange={handleChange2}

                              required

                            ></input>

                          </div>

                          <div className="col-lg-12 col-md-12 mb20">

                            <input

                              type="text"

                              className="form-control"

                              placeholder="Enter Your City"

                              id="city"

                              name="city"

                              value={formData.city}

                              onChange={handleChange4}

                              required

                            ></input>

                          </div>

                          <div class="col-lg-12 col-sm-12 mb20">

                            <textarea

                              type="Message"

                              class="form-control"

                              placeholder="Message"

                              id="message"

                              name="message"

                              value={formData.message}

                              onChange={handleChange3}

                              required

                            ></textarea>

                            <small id="messageerror" class="error"></small>

                          </div>

                          <div>

                            {/* <div className="col-lg-12 col-md-12 mb20">

                              <ReCAPTCHA

                                sitekey={"6LdGiY0oAAAAAH9EQi94D43RkIXkRWpc1x99AUTv"}

                                Secret Key={"6LdGiY0oAAAAALltd2vMsg0i0HeJ9J33rYDM7pnP"}

                                className="g-recaptcha my-3"

                                onChange={onChange}

                              />

                            </div> */}

                            <Modal.Footer className="validationpopup-button-sec">

                              <button

                                className="main-btn mr2"

                                download=""

                                onClick={handleClick}

                              >

                                Submit

                              </button>

                              <button

                                type="close"

                                className="main-btn ml2 closebtn"

                                data-dismiss="modal"

                                onClick={() => {

                                  setShow(false);

                                }}

                              >

                                close

                              </button>

                            </Modal.Footer>

                          </div>

                        </div>

                      </form>

                    </Modal.Body>

                  </Modal>



                  <Modal

                    show={showcart}

                    onHide={handleClosecart}

                    keyboard={false}

                    backdrop="static"

                    className="entry-popup"

                    centered

                  >

                    <div className="modal-header mb-3">

                      <h5 className="modal-title">Add Cart</h5>

                      <button

                        type="button"

                        className="close"

                        onClick={handleClosecart}

                        style={{ border: "none" }}

                      >

                        <span className="contactclosebutton">&times;</span>

                      </button>

                    </div>



                    <Modal.Body>

                      <form onSubmit={handleSubmit}>

                        {/* {error && <div className="alert alert-danger">{error}</div>} */}



                        <div className="row g-3">

                          {/* Update all inputs to use cartformData */}



                          <div className="col-12 mb20 add_to_cart_popup">

                            <div className="input_inner_box">

                              <input

                                type="text"

                                className="form-control"

                                placeholder="Quantity"

                                name="qty"

                                value={cartformData.qty}

                                onChange={carthandleChange}

                                required

                              />

                              <span className="input_sub_inner_box">

                                {cartformData.quantity_variant}

                              </span>

                            </div>

                          </div>



                          {/** Sizes **/}

                          <div className="col-12 mb20 add_to_cart_popup">

                            <div className="input_inner_box">

                              <input

                                type="text"

                                className="form-control"

                                placeholder="Sizes"

                                name="sizes"

                                value={cartformData.sizes}

                                onChange={carthandleChange}

                                required

                              />

                              <span className="input_sub_inner_box">/ 16</span>

                            </div>

                          </div>



                          {/** Carat **/}

                          <div className="col-12 mb20 add_to_cart_popup">

                            <div className="input_inner_box">

                              <select

                                className="form-control"

                                name="carat"

                                value={cartformData.carat}

                                onChange={carthandleChange}

                                required

                              >

                                <option value="" disabled>

                                  Select Carat

                                </option>

                                <option value="22 KT">22 KT</option>

                                <option value="18 KT Yellow Gold">

                                  18 KT Yellow Gold

                                </option>

                                <option value="18 KT Rose Gold">

                                  18 KT Rose Gold

                                </option>

                                <option value="18 KT White Gold">

                                  18 KT White Gold

                                </option>



                                {/* Add more options as needed */}

                              </select>

                              <span className="input_sub_inner_box">CT</span>

                            </div>

                          </div>



                          {/** Weight **/}

                          <div className="col-12 mb20 add_to_cart_popup">

                            <div className="input_inner_box">

                              <input

                                type="text"

                                className="form-control"

                                placeholder="Weight"

                                name="weight"

                                value={cartformData.weight}

                                onChange={carthandleChange}

                                required

                              />

                              <span className="input_sub_inner_box">gms</span>

                            </div>

                          </div>



                          {/** Remarks **/}

                          <div className="col-12 mb20">

                            <textarea

                              rows={5}

                              className="form-control"

                              placeholder="Remarks"

                              name="remarks"

                              value={cartformData.remarks}

                              onChange={carthandleChange}

                              required

                            />

                          </div>

                        </div>



                        <Modal.Footer>

                          <button type="submit" className="main-btn mr2 ">

                            {loading ? "Submitting..." : "Submit"}

                          </button>

                          <button

                            type="button"

                            className="main-btn ml2 closebtn"

                            onClick={handleClosecart}

                          >

                            Close

                          </button>

                        </Modal.Footer>

                      </form>

                    </Modal.Body>

                  </Modal>

                </div>

              </div>

            </Tabs>

          </div>

        </div>

      </section>

    </div>

  );

}



export default Ourproduct;

